import { Card, Col, Image, notification, Row } from "antd";
import React, { useState } from "react";
import { FETCH_COLLECTION_MODAL_DATA_LIST, FETCH_DISLIKE_COLLECTION, FETCH_LIKE_COLLECTION } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { setLikeCollectionId } from "../../redux/slices/likeCollectionIdSlice";
import TruncatedText from "../../helpers/TruncatedText";

const CollectionList = ({ collections, handleSelectedProductId, setOpen, categoryId }) => {


    const isAuthenticated = useSelector((state) => state.initialize.isAuthenticated);



    const edexToken = localStorage.getItem('edexLicenceToken')


    const [likedItems, setLikedItems] = useState({});

    const dispatch = useDispatch();

    const toggleLike = (id, isLiked) => {
        dispatch(setLikeCollectionId(id))
        setLikedItems((prev) => ({
            ...prev,
            [id]: !prev[id]
        }));
        if(!isAuthenticated){
            notification.error({
                message: "To register likes for forms, please Login first.",
                description: "You are not logged in yet. Your likes will not be registered in the system.",
                placement: "topRight",
            });
            setTimeout(()=>{
                setLikedItems({})
            } , 5000)
        }else{
            dispatch({ type: isLiked ? FETCH_DISLIKE_COLLECTION : FETCH_LIKE_COLLECTION });
        }
        dispatch({ type: FETCH_COLLECTION_MODAL_DATA_LIST })

    };



    return (
        <Row gutter={[16, 16]} justify="start" style={{ marginLeft: '0px', marginRight: '0px' }}>
            {collections?.map((collection) => {
                const isLiked = likedItems[collection?.id] ?? collection?.is_favoured_by_user;

                return (
                    <Col key={collection?.id} xs={24} style={{ display: 'flex', justifyContent: 'center', marginLeft: '5px' }}>
                        <Card
                            onClick={() => handleSelectedProductId(collection.id, categoryId, collection.name)}
                            hoverable
                            style={{ width: '100%', height: '250px' }}
                            cover={
                                <Image
                                    preview={false}
                                    alt={collection.name}
                                    src={collection.image}
                                    className="card-image"
                                    onClick={() => {
                                        setOpen(true);
                                    }}
                                    style={{ objectFit: 'cover' }}
                                />
                            }
                            className="product-card"
                        >
                            <div className="item-label">
                                <div className="circle"></div>
                                <TruncatedText text={collection.name}/>
                            </div>
                            <span
                                className={`heart-icon ${isLiked ? 'liked' : ''}`}
                                onClick={() => toggleLike(collection?.id, isLiked)}
                            />
                        </Card>
                    </Col>
                )
            })}
        </Row>
    )
}


export default CollectionList;
